import { createStore, useStore } from 'zustand';

export type AdType = null | 'SALARY_SURVEY' | 'RESUME_DB' | 'GRAD_FAIRS';

const adStore = createStore<{ adType: AdType | null }>(() => ({
  adType: null,
}));

// Action

export function setAdType(adType: AdType) {
  adStore.setState({ adType });
}

// Hook

export function useAdStore() {
  return useStore(adStore);
}
